export default function LocationIcon() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.916748 7.59846C0.916748 3.76523 4.11998 0.666992 7.99462 0.666992C11.8802 0.666992 15.0834 3.76523 15.0834 7.59846C15.0834 9.53007 14.3809 11.3233 13.2247 12.8433C11.9491 14.5199 10.3769 15.9807 8.6072 17.1273C8.20217 17.3923 7.83664 17.4123 7.39212 17.1273C5.61236 15.9807 4.04015 14.5199 2.7755 12.8433C1.6184 11.3233 0.916748 9.53007 0.916748 7.59846ZM5.66194 7.81428C5.66194 9.09841 6.7098 10.1084 7.99462 10.1084C9.28028 10.1084 10.3382 9.09841 10.3382 7.81428C10.3382 6.54015 9.28028 5.48102 7.99462 5.48102C6.7098 5.48102 5.66194 6.54015 5.66194 7.81428Z"
        fill="#9E9E9E"
      />
    </svg>
  );
}
